import { createContext } from 'react';

import { useTabMenuInit } from './tab-menu.hooks';

type TabMenuContextProps = ReturnType<typeof useTabMenuInit>;

export const TabMenuContext = createContext<TabMenuContextProps | undefined>(undefined);
TabMenuContext.displayName = 'TabMenuContext';
